
import { useTranslation } from 'react-i18next';

export default function MapSection() {
  const { t } = useTranslation();
  return (
    <section className="py-20 bg-gray-50" id="map-section">
    
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">{t("contact.visitOffice", { defaultValue: "Visit Our Office" })}</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            {t("contact.officeLocation", { defaultValue: "Located in the heart of Hong Kong's financial district." })}
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {/* Map */}
          <div className="lg:col-span-2">
            <div className="bg-white rounded-2xl shadow-lg overflow-hidden">
              <div className="h-96 lg:h-[500px]">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3692.0234567890123!2d114.17234567890123!3d22.28234567890123!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x340400f8b8b8b8b8%3A0x1234567890abcdef!2sChina%20Resources%20Building%2C%2026%20Harbour%20Rd%2C%20Wan%20Chai%2C%20Hong%20Kong!5e0!3m2!1sen!2shk!4v1234567890123!5m2!1sen!2shk"
                  width="100%"
                  height="100%"
                  style={{ border: 0 }}
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title={t("contact.mapTitle", { defaultValue: "GOLD LABEL GLOBAL LIMITED Office Location" })}
                />
              </div>
            </div>
          </div>

          {/* Location Details */}
          <div className="space-y-6">
            {/* Address Card */}
            <div className="bg-white rounded-2xl p-6 shadow-lg">
              <div className="flex items-center mb-4">
                <div className="w-12 h-12 bg-orange-100 rounded-lg flex items-center justify-center mr-3">
                  <i className="ri-map-pin-line text-xl text-orange-600"></i>
                </div>
                <h3 className="text-xl font-semibold text-gray-900">{t('contact.officeAddress')}</h3>
              </div>
              <div className="text-gray-600 space-y-1">
                <p className="font-medium">GOLD LABEL GLOBAL LIMITED</p>
                <p>{t("contact.addressFloor", { defaultValue: "Room 3404-3406, 34/F." })}</p>
                <p>China Resources Building</p>
                <p>26 Harbour Road, Wanchai</p>
                <p>{t("contact.hongKong", { defaultValue: "Hong Kong" })}</p>
              </div>
              <a 
                href="https://maps.google.com/?q=China+Resources+Building,+26+Harbour+Road,+Wanchai,+Hong+Kong"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center mt-4 text-orange-600 hover:text-orange-700 font-medium cursor-pointer"
              >
                <i className="ri-external-link-line mr-2"></i>
                {t("contact.openMaps", { defaultValue: "Open in Google Maps" })}
              </a>
            </div>

            {/* Quick Actions 
            
            <div className="bg-gradient-to-r from-orange-500 to-yellow-500 rounded-2xl p-6 text-white">
              <h3 className="text-lg font-semibold mb-4">Quick Actions</h3>
              <div className="space-y-3">
                <a 
                  href="tel:+85230083082"
                  className="flex items-center bg-white/20 rounded-lg p-3 hover:bg-white/30 transition-colors cursor-pointer"
                >
                  <i className="ri-phone-line mr-3"></i>
                  <span>Call Office</span>
                </a>
                <a 
                  href="mailto:support@jlbhk.com"
                  className="flex items-center bg-white/20 rounded-lg p-3 hover:bg-white/30 transition-colors cursor-pointer"
                >
                  <i className="ri-mail-line mr-3"></i>
                  <span>Send Email</span>
                </a>
                <a 
                  href="https://maps.google.com/?q=China+Resources+Building,+26+Harbour+Road,+Wanchai,+Hong+Kong"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center bg-white/20 rounded-lg p-3 hover:bg-white/30 transition-colors cursor-pointer"
                >
                  <i className="ri-navigation-line mr-3"></i>
                  <span>Get Directions</span>
                </a>
              </div>
            </div>

            */}
          </div>
        </div>
      </div>
    </section>
  );
}
